import { FC } from "react";

import { useUI } from "@/common/contexts/ui.context";
import { useCart } from "@/features/basket/hooks/use-cart";
import { useUpdateCartItemsMutation } from "@/features/basket/hooks/use-update-cart-items";
import { useStoreProduct } from "@/features/product/contexts/product-context";

type UpdateCartItemButtonProps = {
  children: (arg: UpdateCartItemButtonChildrenProps) => React.ReactElement;
  lineItemId: string;
  sku: string;
};

export type UpdateCartItemButtonChildrenProps = {
  isLoading: boolean;
  handleUpdateCartItem: () => void;
};

export const UpdateCartItemButton: FC<UpdateCartItemButtonProps> = ({
  children,
  lineItemId,
  sku,
}) => {
  const { config } = useStoreProduct();
  const { setModalConfig } = useUI();

  const { mutateAsync: updateCartItem, isLoading } = useUpdateCartItemsMutation();
  const { data: cart } = useCart();

  const handleUpdateCartItem = async () => {
    if (cart && config) {
      await updateCartItem({
        cartId: cart?.id,
        cartVersion: cart?.version,
        items: [{ lineItemId, config, sku }],
        cart
      });
      setModalConfig({
        view: "UPDATE_ITEM_CONFIRMATION",
        autoOpen: true,
      });
    }
  };

  return children({ isLoading, handleUpdateCartItem });
};
